import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { ConsolidationSummaryType } from '@/features/dashboard/types';
import { FrequencyThermometerType } from '../dashboard/types/consolidationTermometroFrequencia';

async function getTermometroFrequencia(params): Promise<FrequencyThermometerType> {
  const api = await getApi();

  const { data } = await api.get<FrequencyThermometerType>('/termometro/frequencia/', {
    params: {
      name: params.name
    }
  });

  return data;
}

type QueryFnType = typeof getTermometroFrequencia;

function useTermometroFrequencia(params) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['termometro-frequencia', params.name],
    queryFn: () => getTermometroFrequencia(params),
  });
}

export { getTermometroFrequencia, useTermometroFrequencia };
